import merge from 'lodash/merge';
import Colors from './colors';
import { themeSelector } from './ThemeSelector';

export function getThemeFontColor(): string {
  return themeSelector({
    white: Colors.black,
    blue: Colors.white,
  });
}

export function getThemeFontBackgroundColor(): string {
  return themeSelector({
    white: Colors.white,
    blue: Colors.blue,
  });
}

export function processHeaderTheme(themeConfig: object): object {
  const headerThemeConfig = {
    overrides: {
      MuiAppBar: {
        colorPrimary: {
          color: getThemeFontColor(),
          backgroundColor: getThemeFontBackgroundColor(),
        },
      },
      MuiTab: {
        wrapper: {
          color: getThemeFontColor(),
          textTransform: themeSelector({
            white: 'uppercase',
            blue: 'none',
          }),
        },
      },
    },
  };
  return merge(themeConfig, headerThemeConfig);
}
